import React, { Component } from 'react'
import axios from 'axios'
import { APIURL } from '../../../config/config'
import { connect } from 'react-redux'

class CarFeatureForm extends Component {

  constructor (props) {
    super(props)

    this.state = {
      lists: [],
      load_data: true,
      danger: false,
      car_feature: '',
      feature_type: [],
      feature_in: [],
      feature_out: [],
      user: {},
      car_id: this.props.car_id,
      feature: '',
      feature_data: [],
      car_feature_list: [],
      action: '',
      car_feature_other: '',
      //selectedItem:'',
    }
    this._handleCarFeatureOther = this._handleCarFeatureOther.bind(this)
    this.handleOnSubmitCarCarFeature = this.handleOnSubmitCarCarFeature.bind(this)
  }

  _handleCarFeatureOther(e) {
    this.setState({
      car_feature_other: e.target.value
    })
  }

  handleOnSubmitCarCarFeature (event) {
    event.preventDefault()
    let car_id = this.state.car_id
    let data = []

    var lists = document.getElementsByName('feature_id')
    //console.log(lists.length)
    for (var i = 0; i < lists.length; i++) {
      var checked = (lists[i].checked) ? 1 : 0
      data.push({'feature_id': lists[i].value, 'checked': checked})
      /*console.log("i =" + i)
       console.log(lists[i].value)
       console.log(lists[i].checked)*/
    }
    /*console.log(data)
     return;*/
    const car_feature_other = this.state.car_feature_other

    if(this.state.action==="insert"){
      axios.post(APIURL + '/car_feature/', {
        car_id: car_id,
        feature_data: data,
        user_created: this.state.user.user,
        user_updated: this.state.user.user,
        car_feature_other: car_feature_other,
      })
        .then(res => {
           //console.log(res)
           alert('บันทึกข้อมูลเรียบร้อยแล้ว');
           this.setState({action: 'update'})
        })
        .catch(function (error) {
           console.log(error)
        })
    }else if(this.state.action==="update"){

        axios.post(APIURL + '/car_feature/update/', {
          car_id: car_id,
          feature_data: data,
          user_created: this.state.user.user,
          user_updated: this.state.user.user,
          car_feature_other: car_feature_other,
        })
        .then(function (response) {
           alert('บันทึกข้อมูลเรียบร้อยแล้ว');
        })
        .catch(function (error) {
          console.log(error)
          //alert("error"+error)
        })
    }

  }

  loadFeatureInData () {
    axios.get(APIURL + '/feature/1')
      .then(res => {
        this.setState({feature_in: res.data})
        //console.log(res.data)
        //alert (res.data)
      }).catch(error => {
      this.setState({feature_in: []})
    })
  }

  loadFeatureOutData () {
    axios.get(APIURL + '/feature/2')
      .then(res => {
        this.setState({feature_out: res.data})
        //console.log(res.data)
        //alert (res.data)
      }).catch(error => {
      this.setState({feature_out: []})
    })
  }

  loadCarFeatureData () {
    //alert (this.state.car_id)
    axios.get(APIURL + '/car_feature/car_id/' + this.state.car_id)
      .then(res => {
        //console.log("=================loadCarFeatureData")
        if (res.data.length > 0) {
          //console.log(res.data)
          const data = res.data
          const feature_in = data.filter((feature) => {
            return feature.feature_type_id === 1
          })
          const feature_out = data.filter((feature) => {
            return feature.feature_type_id === 2
          })
          /*console.log(feature_in)
           console.log(feature_out)
           this.setState({car_feature_list: res.data})*/
          this.setState({
            feature_in: feature_in,
            feature_out: feature_out,
            car_feature_other: feature_in[0].car_feature_other,
            action: 'update'
          })

        } else {
          this.loadFeatureInData()
          this.loadFeatureOutData()
          this.setState({action: 'insert'})
        }

      }).catch(error => {
      //console.log(error)
      this.setState({car_feature_list: []})
    })
  }

  componentDidMount () {
    this.loadCarFeatureData()
  }

  componentWillMount () {
    this.setState({
      user: JSON.parse(this.props.user)
    })
  }

  render () {
    //const { history,user } = this.props

    var feature_in_list = this.state.feature_in.map((feature, index) => {
      return (
        <div className="form-group col-sm-3" key={'in_' + index}>
          <label htmlFor="feature">
            <input type="checkbox"
                   name={'feature_id'}
                   value={feature.feature_id}
                   defaultChecked={feature.checked}
              /*onChange={this.updateCarFeature}*/
            /> {feature.feature_name}
          </label>
          {/*<p>{msg}</p>*/}
        </div>
      )
    })

    var feature_out_list = this.state.feature_out.map((feature, index) => {
      return (
        <div className="form-group col-sm-3" key={'out_' + index}>
          <label htmlFor="feature">
            <input type="checkbox"
                   name={'feature_id'}
                   value={feature.feature_id}
                   defaultChecked={feature.checked}
              /*onChange={this.updateCarFeature}*/
            /> {feature.feature_name}
          </label>
          {/*<p>{msg}</p>*/}
        </div>
      )
    })

    return (
      <form action="" method="post" onSubmit={this.handleOnSubmitCarCarFeature.bind(this)}>
        <div className="col-sm-12">
          <div className="row">
            <div className="col-sm-12" style={{marginTop: 20}}>
              <p><strong>อุปกรณ์ภายใน</strong></p>
            </div>
            {feature_in_list}
          </div>
          <hr/>

          <div className="row">
            <div className="col-sm-12">
              <p><strong>อุปกรณ์ภายนอก</strong></p>
            </div>
            {feature_out_list}
          </div>

          <hr/>
          <div className="row mb-2">
            <div className="col-sm-1">
              <p><strong>อื่นๆ</strong></p>
            </div>
            <div className="col-sm-11">
              <textarea
                 className="form-control"
                 name="car_feature_other"
                 rows="5"
                 style={{width: '100%'}}
                 value={this.state.car_feature_other}
                 onChange={this._handleCarFeatureOther}
              />
            </div>
          </div>

        </div>

        <div className="card-footer text-right">
          <button type="reset"
                  onClick={this.props.onToggle}
                  className="btn btn-sm btn-danger">
            <i className="fa fa-refresh"></i> ยกเลิก
          </button>
          <button type="submit"
                  className="btn btn-sm btn-primary">
            <i className="fa fa-save"></i> { this.state.action === 'insert' ? 'บันทึก' : 'แก้ไข'}
          </button>
          {/*<input type="hidden" id="car_id" name="car_id" value={this.state.car.car_id}/>*/}
        </div>
      </form>
    )

  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(CarFeatureForm)
